import { publicUrls } from "../Api/Auth/AppUrls";

export const findRouteBySlug = (slug) => {
  const slugToRouteMap = {
    "live-class": publicUrls.LiveClassCivil,
    "mechanical-live-class": publicUrls.LiveClassMechanical,
    "free-fe-model-test": publicUrls.FreeFeTestCivil,
    "mechanical-free-fe-model-test": publicUrls.FreeFeTestMechanical,
    "free-fe-materials": publicUrls.FreeFeMaterialsCivil,
    "mechanical-free-fe-materials": publicUrls.FreeFeMaterialsMechanical,
    "paid-model-test": publicUrls.PaidModelTestCivil,
    "mechanical-paid-model-test": publicUrls.PaidModelTestMechanical,
    tutoring: publicUrls.tutoringCivil,
    "mechanical-tutoring": publicUrls.tutoringMechanical,
    "subscription-materials": publicUrls.feSubscriptionCivil,
    "mechanical-subscription-materials": publicUrls.feSubscriptionMechanical,
    "practice-hub": publicUrls.practiceHubCivil,
    "mechanical-practice-hub": publicUrls.practiceHubMechanical,
    "quiz-bank": publicUrls.quizBankCivil,
    "mechanical-quiz-bank": publicUrls.quizBankMechanical,
    simulator: publicUrls.simulatorCivil,
    "mechanical-simulator": publicUrls.simulatorMechanical,
  };

  return slugToRouteMap[slug];
};
